export const UPDATE_HOME = "UPDATE_HOME";

export const updateHome = (value) => ({
  type: UPDATE_HOME,
  value,
});
